var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('cookie-law',{attrs:{"theme":"dark-lime","message":"Sivustomme käyttää evästeitä. Evästeet tekevät sivustomme käyttämisestä helppoa, nopeaa ja käyttäjäystävällistä.","buttonText":"Selvä juttu 👍"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }